<template>
  <div>
    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="400"
      :is-draggable="draggable"
      :is-resizable="resizable"
      :vertical-compact="true"
      :use-css-transforms="true"
    >
      <grid-item v-for="(item, ind) in layout" :key="ind" :static="item.static" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="ind">
        <widget :config="enhanceConfig(item.widget, ind)"></widget>
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout';
import Widget from '../../view-widgets/Widget.vue';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';

export default {
  mixins: [common, configMixin],
  components: {
    GridLayout,
    GridItem,
    Widget,
  },
  data() {
    return {
      draggable: true,
      resizable: true,
      index: 0,
    };
  },
  computed: {
    layout() {
      console.debug('this.viewConfig.widgets', JSON.stringify(this.viewConfig.widgets, null, 2));
      let layout = this.viewConfig.widgets.map((widget, i) => {
        return { x: (i % 3) * 4, y: Math.round(i / 3), w: 4, h: 2, i, widget, static: false };
      });
      return layout;
    },
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
    isMdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  methods: {
    enhanceConfig(config, index) {
      if (this.$route.meta.configIdentifier) {
        const { idPath } = this.$route.meta.configIdentifier;
        return { configId: `${idPath}/${index}`, ...config };
      }
      return config;
    },

    breakpointChangedEvent: function (newBreakpoint, newLayout) {
      console.debug('BREAKPOINT CHANGED breakpoint=', newBreakpoint, ', layout: ', newLayout);
    },
  },
};
</script>

<style scoped>
.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
  border: 1px solid black;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
